import { Images } from "../../../Images";
import BigNum from "../../math/BigNum";
import Values from "../../value/Values";
import OreBonusSkillNode from "./OreBonusSkillNode";
import { SkillIds } from "../SkillIds";
import SkillType from "../SkillType";

export default class OreBonusSkill extends SkillType {
    /**
     * @param {Totals} totals
     * @param {Values} values
     */
    constructor(totals, values) {
        super(SkillIds.ORE_BONUS);

        /**
         * @constant
         * @type {Values}
         */
        this.values = values;

        const inc = 5;
        let cost = 5;

        const oreBonus1 = this.addNode(new OreBonusSkillNode('oreBonus1', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus2 = this.addNode(new OreBonusSkillNode('oreBonus2', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus3 = this.addNode(new OreBonusSkillNode('oreBonus3', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus4 = this.addNode(new OreBonusSkillNode('oreBonus4', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus5 = this.addNode(new OreBonusSkillNode('oreBonus5', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus6 = this.addNode(new OreBonusSkillNode('oreBonus6', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus7 = this.addNode(new OreBonusSkillNode('oreBonus7', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus8 = this.addNode(new OreBonusSkillNode('oreBonus8', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus9 = this.addNode(new OreBonusSkillNode('oreBonus9', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus10 = this.addNode(new OreBonusSkillNode('oreBonus10', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus11 = this.addNode(new OreBonusSkillNode('oreBonus11', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus12 = this.addNode(new OreBonusSkillNode('oreBonus12', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus13 = this.addNode(new OreBonusSkillNode('oreBonus13', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));
    
        cost += inc;

        const oreBonus14 = this.addNode(new OreBonusSkillNode('oreBonus14', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));


        ////////////////////

        cost += inc;

        const oreBonus15 = this.addNode(new OreBonusSkillNode('oreBonus15', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus16 = this.addNode(new OreBonusSkillNode('oreBonus16', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus17 = this.addNode(new OreBonusSkillNode('oreBonus17', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus18 = this.addNode(new OreBonusSkillNode('oreBonus18', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus19 = this.addNode(new OreBonusSkillNode('oreBonus19', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus20 = this.addNode(new OreBonusSkillNode('oreBonus20', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus21 = this.addNode(new OreBonusSkillNode('oreBonus21', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus22 = this.addNode(new OreBonusSkillNode('oreBonus22', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus23 = this.addNode(new OreBonusSkillNode('oreBonus23', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus24 = this.addNode(new OreBonusSkillNode('oreBonus24', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus25 = this.addNode(new OreBonusSkillNode('oreBonus25', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus26 = this.addNode(new OreBonusSkillNode('oreBonus26', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus27 = this.addNode(new OreBonusSkillNode('oreBonus27', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const oreBonus28 = this.addNode(new OreBonusSkillNode('oreBonus28', 
            totals, Images.currency.ore, new BigNum(cost), this, this.values
        ));
        


        oreBonus1.addChildNode(oreBonus2);
        oreBonus2.addChildNode(oreBonus3);
        oreBonus3.addChildNode(oreBonus4);
        oreBonus4.addChildNode(oreBonus5);
        oreBonus5.addChildNode(oreBonus6);
        oreBonus6.addChildNode(oreBonus7);
        oreBonus7.addChildNode(oreBonus8);
        
        oreBonus8.addChildNode(oreBonus9);
        oreBonus9.addChildNode(oreBonus10);
        oreBonus10.addChildNode(oreBonus11);
        oreBonus11.addChildNode(oreBonus12);
        oreBonus12.addChildNode(oreBonus13);
        oreBonus13.addChildNode(oreBonus14);
        oreBonus14.addChildNode(oreBonus15);

        oreBonus15.addChildNode(oreBonus16);
        oreBonus16.addChildNode(oreBonus17);
        oreBonus17.addChildNode(oreBonus18);
        oreBonus18.addChildNode(oreBonus19);
        oreBonus19.addChildNode(oreBonus20);
        oreBonus20.addChildNode(oreBonus21);
        oreBonus21.addChildNode(oreBonus22);

        oreBonus22.addChildNode(oreBonus23);
        oreBonus23.addChildNode(oreBonus24);
        oreBonus24.addChildNode(oreBonus25);
        oreBonus25.addChildNode(oreBonus26);
        oreBonus26.addChildNode(oreBonus27);
        oreBonus27.addChildNode(oreBonus28);

        ///////////////////////////////////
        // Position the nodes in the graph
        ///////////////////////////////////

        // Starting coordinate of the skill
        const startX = -1;
        const startY = 2;

        oreBonus1.setPosition(startX, startY);
        oreBonus2.setPosition(startX - 1, startY);
        oreBonus3.setPosition(startX - 2, startY);
        oreBonus4.setPosition(startX - 3, startY);
        oreBonus5.setPosition(startX - 4, startY);
        oreBonus6.setPosition(startX - 5, startY);
        oreBonus7.setPosition(startX - 6, startY);

        oreBonus8.setPosition(startX - 6, startY - 1);
        oreBonus9.setPosition(startX - 5, startY - 1);
        oreBonus10.setPosition(startX - 4, startY - 1);
        oreBonus11.setPosition(startX - 3, startY - 1);
        oreBonus12.setPosition(startX - 2, startY - 1);
        oreBonus13.setPosition(startX - 1, startY - 1);
        oreBonus14.setPosition(startX, startY - 1);

        oreBonus15.setPosition(startX, startY - 2);
        oreBonus16.setPosition(startX - 1, startY - 2);
        oreBonus17.setPosition(startX - 2, startY - 2);
        oreBonus18.setPosition(startX - 3, startY - 2);
        oreBonus19.setPosition(startX - 4, startY - 2);
        oreBonus20.setPosition(startX - 5, startY - 2);
        oreBonus21.setPosition(startX - 6, startY - 2);

        oreBonus22.setPosition(startX - 6, startY - 3);
        oreBonus23.setPosition(startX - 5, startY - 3);
        oreBonus24.setPosition(startX - 4, startY - 3);
        oreBonus25.setPosition(startX - 3, startY - 3);
        oreBonus26.setPosition(startX - 2, startY - 3);
        oreBonus27.setPosition(startX - 1, startY - 3);
        oreBonus28.setPosition(startX, startY - 3);
    }
}